<template>
  <div class="auth-card  text-center mb-8" :class="{android: !$store.getters['auth/isTA']}">
    <h2 class="auth-card__title mb-2">Спасибо, вы прошли тест полностью!</h2>
      <div v-if="testData.send_mail">На ваш адрес почты отправлено письмо с доступом в Личный кабинет для того, чтобы вы смогли посмотреть результаты.</div>
    <div :class="{android: !$store.getters['auth/isTA']}" />
    <FeedbackTest :finishStep="true" v-if="testData.is_feedback_available && !feedBackFinished"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FeedbackTest from './FeedbackTest.vue';

export default {
  name: 'Finish',
  components: { FeedbackTest },
  computed: {
    ...mapGetters({
      testData: 'testing/testing/testData',
      feedBackFinished: 'testing/testing/feedBackFinished'
    }),
  }

};
</script>
